import { toCsv, type CsvValue } from "@/lib/csv";

/** A column of a results table. `get` returns the raw value (used for CSV); `format` is what is shown on screen. */
export interface TableColumn<Row> {
  key: string;
  header: string;
  get: (row: Row) => CsvValue;
  format?: (row: Row) => string;
  align?: "left" | "right";
}

/** CSV with the site's safe writer (formula-injection guard, UTF-8 BOM). Raw values, not display strings. */
export function tableToCsv<Row>(rows: Row[], columns: TableColumn<Row>[]): string {
  const keyed = rows.map((r) => Object.fromEntries(columns.map((c) => [c.key, c.get(r)])) as Record<string, CsvValue>);
  return toCsv(keyed, columns.map((c) => ({ key: c.key, header: c.header })));
}

/** Tab-separated text of what is shown, which pastes into a spreadsheet cell by cell. */
export function tableToTsv<Row>(rows: Row[], columns: TableColumn<Row>[]): string {
  const clean = (s: string) => s.replace(/[\t\r\n]+/g, " ");
  const head = columns.map((c) => clean(c.header)).join("\t");
  const body = rows.map((r) => columns.map((c) => clean(c.format ? c.format(r) : String(c.get(r) ?? ""))).join("\t"));
  return [head, ...body].join("\n");
}
